import type { ComponentType, FC } from 'react';
import type { WorkflowActionInputProps } from '../../registries/registry-types';

// AR components are untyped JS files — PropTypes inference creates types that don't satisfy
// ComponentType<P> constraints. Cast to ComponentType<WorkflowActionInputProps> at the call
// site using an intermediate unknown cast to avoid TypeScript fighting us here.
// TODO: Remove this workaround when AR components are converted to TypeScript.
//
// CONTRACT NOTE: Some AR components (e.g. TextAreaInput) only call onChange on blur, not on
// every keystroke. This means the workflow draft won't reflect the latest typed value until
// the field loses focus. WorkflowDrawer's handleSave flushes via handleStepBlur before
// submitting, but only after the user has blurred any focused input (clicking Save triggers
// a blur first). This is an acceptable limitation of the AR adapter bridge.
export const adaptFromAutomationRules =
  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
  (ArComponent: ComponentType<any>): FC<WorkflowActionInputProps> => {
    const Adapted: FC<WorkflowActionInputProps> = ({ draft, label = '', onUpdate }) => (
      // AR components check `parameter === undefined` to detect a new (unsaved) action.
      // Workflow drafts initialize with null, so we coerce null → undefined here.
      <ArComponent
        hasError={false}
        inputValueProps={{ parameter: draft.parameter ?? undefined, intParameter: draft.intParameter ?? undefined }}
        label={label}
        onChange={(updates: Parameters<typeof onUpdate>[0]) => onUpdate(updates)}
      />
    );
    Adapted.displayName = `Adapted(${ArComponent.displayName ?? ArComponent.name ?? 'Unknown'})`;
    return Adapted;
  };
